import { RearchFeatureNames } from 'access/types';
import { BulkUploadTypes } from 'constants/bulkUpload';
import permissions from 'constants/permissions';
import { FeatureFlags } from 'types';

type BulkAction = {
  label: string;
  description: string;
  href: string;
  feature?: FeatureFlags;
  permissions?: string[];
  rearchFeatures?: RearchFeatureNames[];
};

export const bulkActions: Record<string, BulkAction> = {
  'salary-revision': {
    label: 'Salary Revision',
    description: 'Revise salary of all your employees, add effective date in bulk',
    href: '/bulk-uploads/salary-revision',
  },
  'addition-deduction': {
    label: 'Addition and Deduction',
    description: 'Add or deduct amounts for multiple employees in bulk',
    href: '/bulk-uploads/addition-deduction-lop',
    permissions: [permissions.BULK_ADDITION_DEDUCTION],
    rearchFeatures: ['isAdditionsDisabled', 'isDeductionsDisabled', 'isLOPDisabled'],
  },
  'full-final-initiation': {
    label: 'Full & Final Initiation',
    description: 'Initiate full and final settlement for employees in bulk',
    href: `/bulk-uploads/initiate?type=${BulkUploadTypes.TYPE_BULK_FNF_INITIATION}`,
    feature: 'bulk-fnf',
    permissions: [permissions.EMPLOYEE_DISMISSAL],
  },
  'full-final-settlement': {
    label: 'Full & Final Settlement',
    description: 'Settle full and final amounts for employees in bulk',
    href: `/bulk-uploads/initiate?type=${BulkUploadTypes.TYPE_BULK_FNF_SETTLEMENT}`,
    feature: 'bulk-fnf',
    permissions: [permissions.EMPLOYEE_DISMISSAL],
  },
  'compensation-adjustment': {
    label: 'Compensation Adjustment',
    description: 'Add Recurring deductions, VPF, perquisites and flexible benefits in bulk',
    href: `/bulk-uploads/initiate?type=${BulkUploadTypes.TYPE_BULK_COMPENSATION_ADJUSTMENT}`,
    permissions: [permissions.BULK_ADDITION_DEDUCTION],
    feature: 'reArchM3S3',
  },
};
